"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldDateRangeStable = exports.className = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const dateTime_1 = require("../../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const mobilePlatform_1 = require("../../../../utils/mobilePlatform");
const stable_1 = require("../../../Date/Range/stable");
const index_1 = require("../index");
const useOutDateRangeClick_1 = require("./useOutDateRangeClick");
require("./index.scss");
exports.className = 'form-field-date-range';
const FormFieldDateRangeStable = (props) => {
    const { fromField, toField, setValue, dateRestrictions, calendarView = 'auto', hidden, additionClassNames, modificators, } = props;
    const [isOpenDatePicker, setIsOpenPicker] = (0, react_1.useState)(false);
    const [focus, setFocus] = (0, react_1.useState)('from');
    const { rootRef } = (0, useOutDateRangeClick_1.useOutDateRangeClick)(() => {
        var _a, _b;
        if (!isOpenDatePicker)
            return;
        setIsOpenPicker(false);
        (_a = fromField.setNativeValue) === null || _a === void 0 ? void 0 : _a.call(fromField, (0, dateTime_1.standardizeInputDate)(fromField.nativeValue));
        (_b = toField.setNativeValue) === null || _b === void 0 ? void 0 : _b.call(toField, (0, dateTime_1.standardizeInputDate)(toField.nativeValue));
    });
    const isMobile = (0, mobilePlatform_1.checkMobilePlatform)();
    const fromFieldProps = {
        ...fromField,
        onFocus: () => {
            setFocus('from');
            setIsOpenPicker(true);
        },
        addonIcon: 'calendar',
        placeholder: (0, moment_1.default)().format(dateTimeFormat_1.DATE_FORMAT),
        inputMode: isMobile ? 'none' : 'text',
    };
    const toFieldProps = {
        ...toField,
        onFocus: () => {
            setFocus('to');
            setIsOpenPicker(true);
        },
        addonIcon: 'calendar',
        placeholder: (0, moment_1.default)().add(1, 'day').format(dateTimeFormat_1.DATE_FORMAT),
        inputMode: isMobile ? 'none' : 'text',
    };
    const pickerDateRangeProps = {
        restrictions: dateRestrictions,
        focus,
        dateRange: {
            from: fromField.value,
            to: toField.value,
        },
        onChange: {
            from: (result) => {
                var _a;
                setFocus('to');
                (_a = fromField.setValue) === null || _a === void 0 ? void 0 : _a.call(fromField, result);
            },
            to: (result) => {
                var _a;
                setFocus('from');
                (_a = toField.setValue) === null || _a === void 0 ? void 0 : _a.call(toField, result);
            },
        },
        onReset: () => {
            setFocus('from');
            setValue === null || setValue === void 0 ? void 0 : setValue({});
        },
        onClose: () => {
            setIsOpenPicker(false);
        },
        resetHidden: !(fromField.value || toField.value),
    };
    const classNames = (0, classFunctions_1.getClassNames)(exports.className, [
        modificators,
    ], additionClassNames);
    const calendarClassNames = (0, classFunctions_1.getClassNames)(`${exports.className}__calendar`, [
        calendarView === 'horizontal' ? 'horizontal' : undefined,
        calendarView === 'vertical' ? 'vertical' : undefined,
    ]);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: classNames, ref: rootRef },
        react_1.default.createElement(index_1.FormFieldStable, { ...fromFieldProps }),
        react_1.default.createElement(index_1.FormFieldStable, { ...toFieldProps }),
        react_1.default.createElement("div", { className: calendarClassNames }, isOpenDatePicker && react_1.default.createElement(stable_1.DateRangePicker, { ...pickerDateRangeProps }))));
};
exports.FormFieldDateRangeStable = FormFieldDateRangeStable;
//# sourceMappingURL=stable.js.map